export const getTicketRoles = (userInfoData) => {
  const isManager = userInfoData?.ticket_account_type === "manager";
  const isSupervisor = userInfoData?.ticket_account_type === "supervisor";
  const isReceptionist = userInfoData?.ticket_account_type === "receptionist";
  const isAdmin = userInfoData?.ticket_account_type === "admin";
  const isClusterManager =
    userInfoData?.ticket_account_type === "cluster_manager";

  return {
    isManager,
    isSupervisor,
    isReceptionist,
    isAdmin,
    isClusterManager,
  };
};
